import { API_BASE_URL } from '@/environment'
import { customFetch } from '@/service/v3/apiV3Utils'
import { queryParams } from '@attensi/utils'
import type { GetCompanyProductsParams } from './productsParams'

const API_ADMIN_NAMESPACE = 'api/v3/admin'

export const getCompanyProducts = async ({
  filterPolicyId,
  filterProductType,
  filterTerm,
  filterContent,
  filterNoScore,
  filterPublished,
  filterOrganizationStructureId,
  filterProductTagIds,
  fields,
  include,
  nameKey,
  pageNumber,
  pageSize,
  sort,
  sortLocale,
}: GetCompanyProductsParams) => {
  const productQueryParams = {
    'filter[product_type]': filterProductType,
    'filter[policy_id]': filterPolicyId,
    'filter[term]': filterTerm,
    'filter[content]': filterContent,
    'filter[no_score]': filterNoScore,
    'filter[published]': filterPublished,
    'filter[organization_structure_id]': filterOrganizationStructureId,
    'filter[product_tag_ids]': filterProductTagIds,
    'fields[products]': fields,
    'page[number]': pageNumber,
    'page[size]': pageSize,
    include,
    sort,
    sort_locale: sortLocale,
  }

  const url = queryParams(
    `${API_BASE_URL}/${API_ADMIN_NAMESPACE}/companies/${nameKey}/products`,
    productQueryParams
  )
  return await customFetch(url, {
    method: 'GET',
  }).then((response) => response.json())
}

export const deleteProductById = async (productId: number) => {
  const url = `${API_BASE_URL}/${API_ADMIN_NAMESPACE}/products/${productId}`
  return await customFetch(url, {
    method: 'DELETE',
  })
}

export const getProductById = async (productId: string) => {
  const url = `${API_BASE_URL}/${API_ADMIN_NAMESPACE}/products/${productId}`
  return await customFetch(url, {
    method: 'GET',
  }).then((response) => response.json())
}

export const getUserProductsReadyForApproval = async (
  userId: string,
  pageSize: string,
  pageNumber: string
) => {
  const params = {
    'page[size]': pageSize,
    'page[number]': pageNumber,
  }
  const url = queryParams(
    `${API_BASE_URL}/${API_ADMIN_NAMESPACE}/users/${userId}/activity_product_approve_list`,
    params
  )

  return customFetch(url, {
    method: 'GET',
  }).then((response) => response.json())
}
